// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"KBuH7","shade":"ntZPw","modal":"d5maC"};